<template>
  <el-dialog
    :append-to-body="false"
    width="80%"
    :title="curRow.title"
    center=""
    :visible.sync="visible"
    :before-close="resetdialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form ref="elFormDom" inline :model="table.params" size="small">
      <el-form-item label="企业名称" prop="company_name">
        <el-input
          clearable
          v-model="table.params.company_name"
          placeholder="请输入"
          @keyup.enter.native.prevent="handleSearch"
        ></el-input>
      </el-form-item>
      <el-form-item label="岗位名称" prop="job_name">
        <el-input
          clearable
          v-model="table.params.job_name"
          placeholder="职位标题/岗位类型"
          @keyup.enter.native.prevent="handleSearch"
        ></el-input>
      </el-form-item>
      <el-form-item label="热门岗位" prop="hot_type">
        <el-select
          v-model="table.params.hot_type"
          size="mini"
          filterable
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in hottypelist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch"
          >查询
        </el-button>
        <el-button icon="el-icon-refresh-right" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <TablePlus
      :loading="table.loading"
      :data="table.data"
      :total="table.total"
      has-pagination
      :max-height="500"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column type="index" label="序号" width="80" />
      <el-table-column prop="title" label="职位标题" show-overflow-tooltip />
      <el-table-column prop="job_id_str" label="岗位类型" show-overflow-tooltip />
      <el-table-column prop="company_name" label="所属企业" show-overflow-tooltip />
      <el-table-column prop="salary_str" label="薪资待遇/元" show-overflow-tooltip />
      <el-table-column prop="num" label="投递人次" show-overflow-tooltip />
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="{ row, $index }">
          <el-popover
            :ref="`hotPopover_${$index}`"
            placement="left"
            width="300"
            trigger="click"
            @show="initHotForm(row, $index)"
          >
            <div style="margin-bottom: 8px; font-weight: 600">设置热门类型</div>
            <el-checkbox-group v-model="hotForm[$index]" class="hot-checkbox-group">
              <div class="hot-checkbox-grid">
                <el-checkbox
                  v-for="item in hottypelist"
                  :key="item.id"
                  :label="item.id"
                  border
                  size="mini"
                >{{ item.name }}</el-checkbox>
              </div>
            </el-checkbox-group>
            <div style="text-align: right; margin-top: 10px">
              <el-button size="mini" @click="closeHotPopover($index)">取消</el-button>
              <el-button
                size="mini"
                type="primary"
                :loading="hotLoading === $index"
                @click="saveHotJob(row, $index)"
              >保存</el-button>
            </div>
            <template #reference>
              <span
                class="hot-type-ref"
                :title="row.hot_types ? getHotTypeNames(row.hot_types) : ''"
              >
                {{ row.hot_types ? getHotTypeNames(row.hot_types) : '加入热门岗位' }}
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
    </TablePlus>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import TablePlus from "@/components/TablePlus";
export default {
  name: "WealEdit",
  mixins: [mixinTable],
  components: {
    TablePlus,
  },
  data() {
    return {
      companyList_: [],
      visible: false,
      loading: false,
      // 热门岗位 popover 表单：{ [$index]: number[] }
      hotForm: {},
      // 当前正在保存的行 index，-1 表示无
      hotLoading: -1,
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
          company_name: "",
          job_name: "",
          hot_type: "",
        },
        data: [],
        total: 0,
      },
      curRow: null,
      // 热门类型：1-专业技术类；2-行政类；3-生产类；4-财务类；5-实习岗；6-人力资源类；7-市场营销类；8-客户服务类；
      hottypelist: [
        { name: "专业技术类", id: 1 },
        { name: "行政类", id: 2 },
        { name: "生产类", id: 3 },
        { name: "财务类", id: 4 },
        { name: "实习岗", id: 5 },
        { name: "人力资源类", id: 6 },
        { name: "市场营销类", id: 7 },
        { name: "客户服务类", id: 8 },
      ],
    };
  },
  methods: {
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    addCom() {
      let dom = this.$refs.addCompanyRef;
      dom.toggle(true);
      dom = null;
    },
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 获取详情
    getDetail(row) {
      this.curRow = row;
      // this.getCompanyList();
      this.getTable();
    },
    getTable() {
      let params_ = {
        id: this.curRow.id,
        ...this.table.params,
      };
      this.table.loading = true;
      this.$http
        .get("/admin/fair/jobDetail", {
          params: params_,
        })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            // 预初始化 hotForm，避免 el-checkbox-group 读到 undefined
            this.table.data.forEach((_, idx) => {
              if (!this.hotForm[idx]) {
                this.$set(this.hotForm, idx, []);
              }
            });
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    resetdialog(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    handleCommand(e, row) {
      console.log(e, row, "77");
      window.open(row.refund_img[e]);
    },
    // 根据 hot_types 字符串（逗号分隔的 id）获取对应的名称
    getHotTypeNames(hotTypes) {
      if (!hotTypes) return "";
      return hotTypes
        .split(",")
        .filter(Boolean)
        .map((id) => {
          const found = this.hottypelist.find((item) => item.id === Number(id));
          return found ? found.name : id;
        })
        .join("、");
    },
    // 初始化 popover 内的选中值（popover 弹出时触发）
    initHotForm(row, $index) {
      let arr = [];
      if (row.hot_types && typeof row.hot_types === "string") {
        arr = row.hot_types
          .split(",")
          .filter(Boolean)
          .map((id) => Number(id));
      }
      this.$set(this.hotForm, $index, arr);
    },
    // 保存热门岗位设置
    saveHotJob(row, $index) {
      const list = this.hotForm[$index] || [];
      this.hotLoading = $index;
      this.$http
        .post("/admin/fair/setHotJob", {
          id: this.curRow.id,
          job_id: row.id,
          hot_types: list.join(","),
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("保存成功");
            this.closeHotPopover($index);
            this.getTable();
          }
        })
        .finally(() => {
          this.hotLoading = -1;
        });
    },
    // 关闭 popover
    closeHotPopover($index) {
      const popover = this.$refs[`hotPopover_${$index}`];
      if (popover) popover.showPopper = false;
    },
  },
};
</script>
<style scoped>
.fs {
  padding: 0 0 20px;
}
.hot-checkbox-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
}
.hot-checkbox-grid ::v-deep .el-checkbox {
  display: block;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
}
.hot-checkbox-grid ::v-deep .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
.hot-type-ref {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
  color: #409eff;
  cursor: pointer;
}
</style>
